import { dangerouslyFetchAllPages } from '@eb/http';
import { GenericLazyString } from '@eb/i18n';
import React, { PureComponent } from 'react';
import { formatUrl } from 'url-lib';
import AppDiscoverySection from '../components/AppDiscoverySection/AppDiscoverySection';
import {
    AppCardAppNameTextSizeProp,
    AppCardLinkProp,
    AppListColumnNumbersProp,
    AppProp,
    RecommendationPageProp,
    WidgetTypesProps,
    WIDGET_TYPE_RECOMMENDED,
} from '../constants';

const APPS_API_URL = '/api/v3/apps/';

export default class AppDiscoveryWidget extends PureComponent<
    {
        appNameTextSize: AppCardAppNameTextSizeProp;
        columnNumber: AppListColumnNumbersProp;
        linkComponentType?: AppCardLinkProp;
        linkLabel?: string | GenericLazyString;
        linkUrl?: string;
        maxApps?: number;
        recommendationPage?: RecommendationPageProp;
        sectionTitle?: string | GenericLazyString;
        shouldTrackAppRecLoaded?: boolean;
        type: WidgetTypesProps;
    },
    {
        apps: Array<AppProp>;
        hasFailed: boolean;
        isLoading: boolean;
    }
> {
    _isMounted = false;

    state = {
        apps: [],
        hasFailed: false,
        isLoading: true,
    };

    componentDidMount() {
        this._isMounted = true;
        this._fetchApps();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _fetchApps = () => {
        const { recommendationPage, type } = this.props;
        const params = {
            picks: type,
            'expand.app': 'details',
        };

        this.setState({
            isLoading: true,
        });

        if (type === WIDGET_TYPE_RECOMMENDED && recommendationPage) {
            ((params as unknown) as {
                recommendation_page: RecommendationPageProp;
            })['recommendation_page'] = recommendationPage;
        }

        dangerouslyFetchAllPages(
            formatUrl(APPS_API_URL, params),
            'apps',
            'continuation',
        ).then(
            (res: { objects: Array<AppProp> }) => {
                if (this._isMounted) {
                    this.setState({
                        isLoading: false,
                        apps: res.objects,
                        hasFailed: false,
                    });
                }
            },
            () => {
                if (this._isMounted) {
                    this.setState({
                        isLoading: false,
                        hasFailed: true,
                    });
                }
            },
        );
    };

    render() {
        const {
            appNameTextSize,
            columnNumber,
            linkComponentType,
            linkLabel,
            linkUrl,
            maxApps,
            sectionTitle,
            shouldTrackAppRecLoaded,
            type,
        } = this.props;

        const { apps, hasFailed, isLoading } = this.state;

        return (
            <AppDiscoverySection
                appNameTextSize={appNameTextSize}
                apps={apps}
                columnNumber={columnNumber}
                hasFailed={hasFailed}
                isLoading={isLoading}
                linkComponentType={linkComponentType}
                linkLabel={linkLabel}
                linkUrl={linkUrl}
                maxApps={maxApps}
                refreshContentHandler={this._fetchApps.bind(null, type)}
                sectionTitle={sectionTitle}
                shouldTrackAppRecLoaded={shouldTrackAppRecLoaded}
            />
        );
    }
}
